import React from 'react';
import { useAdminListParams } from '../shared/useAdminListParams';
import { AdminListToolbar } from '../shared/AdminListToolbar';
import { getImportFilters } from './ImportsTable/ImportFilters';
import { ImportsTable } from './ImportsTable';
import { ImportMenuButton } from './ImportMenuButton';

/**
 * Import history at /admin/imports: the toolbar (Type and Status filters, no search, and the
 * Import menu to start one) and the imports grid (ImportsTable), paged, sorted and filtered
 * on the server.
 */
export const ImportsListPage = () => {
	const { gridProps, filters, setFilter, clearFilters, listParams } =
		useAdminListParams('imports');

	return (
		<>
			<AdminListToolbar
				filters={getImportFilters({ filters, setFilter })}
				onClearFilters={clearFilters}
				primaryActions={<ImportMenuButton />}
			/>
			<ImportsTable listParams={listParams} gridProps={gridProps} />
		</>
	);
};
